import { eachL, go, mapL, takeAll, takeAllC } from "fxjs/es";
export const deepCloneNode = async (node) => {
  const clone_node = await new Promise((resolve, reject) =>
    requestAnimationFrame(() => {
      try {
        resolve(node.cloneNode(false));
      } catch (error) {
        reject(error);
      }
    })
  );
  await go(
    Array.from(node.childNodes),
    mapL(deepCloneNode),
    takeAllC,
    eachL(
      (clone_child_node) =>
        new Promise((resolve, reject) =>
          requestAnimationFrame(() => {
            try {
              clone_node.appendChild(clone_child_node);
              resolve();
            } catch (error) {
              reject(error);
            }
          })
        )
    ),
    takeAll
  );
  return clone_node;
};
